export default function telephoneFlag() {
  const forms = document.querySelectorAll("form");

  if (!forms.length) return;

  window.addEventListener("load", function () {
    forms.forEach((form) => {
      // find only the phone fields inside THIS form
      const phoneFields = form.querySelectorAll(".phoneiti");
      if (!phoneFields.length) return;

      phoneFields.forEach((input) => {
        const iti = window.intlTelInput(input, {
          hiddenInput: (telInputName) => ({
            phone: "phone_full",
            country: "country_code",
          }),
          initialCountry: "ae",
          formatOnDisplay: false,
          nationalMode: false,
          separateDialCode: true,
          // autoPlaceholder: "off",
          utilsScript:
            "https://cdn.jsdelivr.net/npm/intl-tel-input@25.10.10/build/js/utils.js",
          geoIpLookup: function (callback) {
            fetch("https://ipinfo.io/json")
              .then((res) => res.json())
              .then((data) => callback(data.country || "us"));
          },
        });

        // update on input
        input.addEventListener("input", () => {
          updateHidden(form, iti);
        });

        // update on country change
        input.addEventListener("countrychange", () => {
          updateHidden(form, iti);
        });
      });
    });
  });

  function updateHidden(form, iti) {
    try {
      const fullPhone = iti.getNumber();

      // find hidden inputs ONLY inside this form
      const hiddenPhone = form.querySelector("[name='phone_full']");
      const hiddenCountry = form.querySelector("[name='country_code']");

      if (hiddenPhone) hiddenPhone.value = fullPhone;
      if (hiddenCountry)
        hiddenCountry.value = iti.getSelectedCountryData().iso2;
    } catch (e) {
      console.error("Hidden field update error:", e);
    }
  }
}
